import React from "react";
import { connect } from 'react-redux';
import { setInfo, initializeApp } from '../redux/actionList';
import withRouterCompat from "../objects/CommonUse/with_router_compat";
import buildUrl from "../objects/CommonUse/build_URL";
import { setHeadersForFetch } from "../objects/CommonUse/set_headers_for_fetch";
import Config from "../config";
import WaitTimeSpinner from "./shared-components/wait_time_spinner";
import buildTestTypeArr from "../objects/CommonUse/build_test_type_arr";
import defaultAccountSettings from "../pages/Text/default_account_settings";
import ConfigFile from "../datasets/config_file";
import setTempTokenForFetch from "../objects/CommonUse/set_temp_token_for_fetch";


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    initializeApp: initializeApp
};

class AppInitializer extends React.Component {
    constructor(props) {
            super(props);
          this.state = {
        initialized: false,
        headers: setHeadersForFetch(),
        environment: Config.dataURL.currentEnv,
        subProcess: "appInitializer",
        pendingNavigation: false
    }
        this.defaultAccountSettings = defaultAccountSettings;
        if (ConfigFile.gameStartItems.enableUnlockedTemplate === true){
            this.defaultAccountSettings.startGameOptions.gameTemplateArr.push("unlockedFeaturesEnabled");
        }
}
   
async componentDidMount() {
    console.log("appInitializer executed");
    let accountNbr = sessionStorage.getItem("userAccountNbr");
    this.props.initializeApp();
    let tasks = [];
    tasks.push(this.loadGameData());
    if (accountNbr) {
        if (accountNbr !== "Individual"){
            tasks.push(this.loadAccountSettings(accountNbr));
        }else{
            this.props.setInfoRedux(this.defaultAccountSettings, "accountSettings");
        }
    }

    tasks.push(this.loadPlayerTest());

    await Promise.all(tasks);
    if (accountNbr === "Individual"){
        if (this.moneyMgmtTestArr && this.moneyMgmtTestArr.length > 0){
            this.defaultAccountSettings.testSettings = {testType: "mid-test", forceTest: false};
            this.props.setInfoRedux(this.defaultAccountSettings, "accountSettings");
        }
    }
 
    // all fetches are complete now
    this.setState({ initialized: true }, () => {
        if (this.props.onComplete) {
            this.props.onComplete();   // correct timing
        }
    });

    let gameSettings = {};
    if (this.gameData && this.gameData.gameSettings){
        gameSettings = this.gameData.gameSettings;
    }else{
        gameSettings = {flipCard: true, gameSpinner: true, trainAnimation: true};
    }
    this.props.setInfoRedux(gameSettings, "gameSettings");
}

async loadGameData() {
    try {
        this.username = sessionStorage.getItem("username");
        const funcName = "loadGame";
        const urlParm = "?mode=fullLoad";
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        const response = await fetch(uri, { method: 'GET', headers: this.state.headers });

        if (response.ok) {
            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;

            if (statusCode === 200) {
                if (this.state.eventTracker === true) {
                    this.getEventsTracker();
                }
                sessionStorage.setItem("gameID", output.body.gameID);
                this.gameData = output.body;
                this.props.setInfoRedux(output.body, "gameData");
                this.props.setInfoRedux(true, "gameExists");
            } else {
                if (statusCode === 250) {
                    this.props.setInfoRedux(false, "gameExists");
                } else {
                    const errorObj = {
                        function: funcName,
                        subProcess: this.state.subProcess,
                        status: statusCode,
                        message: output.body.message
                    };
                    this.processError(errorObj);
                }
            }
        }
    } catch (error) {
        // Handles network errors or JSON parsing errors
        console.error("Error loading game data:", error);
        const errorObj = {
            function: "loadGame",
            subProcess: this.state.subProcess,
            status: "NETWORK_ERROR",
            message: error.message
        };
        this.processError(errorObj);
    }
}

async loadPlayerTest() {
    const funcName = "loadFinancialLiteracyTest";
    const username = sessionStorage.getItem("username");
    const playerArr = [username];
    const urlParm = "?userArr=" + playerArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, {
            method: 'GET',
            headers: this.state.headers
        });

        if (!response.ok) {
            // Network-level error
            this.processError({
                function: funcName,
                status: response.status,
                message: "Network response was not ok"
            });
            return;
        }

        const data = await response.json();
        const output = JSON.parse(data);
        const statusCode = output.statusCode;
        if (statusCode === 200) {
            const moneyMgmtTestData = output.body;
            this.moneyMgmtTestArr = buildTestTypeArr(moneyMgmtTestData);

            // Store in Redux
            this.props.setInfoRedux(this.moneyMgmtTestArr, "moneyMgmtTestArr");
        } else if (statusCode === 250) {
            const moneyMgmtTestArr = [{testType: "none"}];
            this.props.setInfoRedux(moneyMgmtTestArr, "moneyMgmtTestArr");
        } else {
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body?.message
            };
            this.processError(errorObj);
        }

    } catch (err) {
        // Handles network errors or JSON parsing errors
        console.error("Error loading game data:", err);
        const errorObj = {
            function: "loadPlayerTest",
            subProcess: this.state.subProcess,
            status: "NETWORK_ERROR",
            message: err.message
        };
        this.processError(errorObj);
    }
}
 
async loadAccountSettings(accountNbr) {
    const funcName = "loadAccountSettings";
    const urlParm = "?accountNbr=" + accountNbr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);

    try {
        const response = await fetch(uri, {
            method: 'GET',
            headers: this.state.headers
        });

        if (!response.ok) {
            // not a 200-level response
            this.processError({
                function: funcName,
                subProcess: this.state.subProcess,
                status: response.status,
                message: "Network response was not ok",
                errorObject: { urlParm }
            });
            return;
        }

        const data = await response.json();
        const output = JSON.parse(data);
        const statusCode = output.statusCode;
        if (statusCode === 200) {
            const accountSettingsData = output.body;
            // store data in redux
            this.props.setInfoRedux(accountSettingsData, "accountSettings");
        } else if (statusCode === 250) {
            // load default
            this.defaultAccountSettings.accountNbr = accountNbr;
            const enableUnlockedFeaturesTemplate = ConfigFile.gameStartItems.enableUnlockedTemplate;
            if (enableUnlockedFeaturesTemplate === true){
                this.defaultAccountSettings.startGameOptions.gameTemplateArr.push("unlockedFeaturesEnabled");
            }
            this.props.setInfoRedux(this.defaultAccountSettings, "accountSettings");
        } else {
            // error case
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: statusCode,
                message: output.body.message,
                errorObject: { urlParm }
            };
            this.processError(errorObj);
        }

    } catch (err) {
        // Handles network errors or JSON parsing errors
        console.error("Error loading game data:", err);
        const errorObj = {
            function: "loadAccountSettings",
            subProcess: this.state.subProcess,
            status: "NETWORK_ERROR",
            message: err.message
        };
        this.processError(errorObj);
    }
}

processError(errorObj){
    this.addRecordToLogfile(errorObj);
    alert  ("Uh oh!  Something unexpected has occurred " +
            "error has been logged and will be addressed. " +
            "For now click OK, then return to the process " +
            "where you were and try again.");
    this.onNavigate("");
}

addRecordToLogfile(errorObj){
    console.log("errorObj is: ", errorObj);
    if (errorObj.status === 250){
        errorObj.message = "No record found";
    }
    let urlParm = "";
    let headers = "";
    const authToken = JSON.parse(sessionStorage.getItem('sessionToken'));
    if (authToken === null){
        headers = setTempTokenForFetch();
        urlParm = "?tokenType=TempToken";
    }else{
        headers = setHeadersForFetch();
    }  
    if (!errorObj.errorObject){
        errorObj.errorObject = {info: "no error object provided"};
    }
    const logFileBody =  {
        mainProcess: "login",
        subProcess: errorObj.subProcess,
        function: errorObj.function,
        status: errorObj.status,
        message: errorObj.message,
        errorObj: errorObj.errorObject
    }
    console.log("logFileBody is: ", logFileBody);
    let funcName = "saveLogFile"; 
   
    const uri = buildUrl(this.state.environment, funcName, urlParm)
    fetch (uri,  
        {method: 'POST', 
         headers: headers, 
         body: JSON.stringify(logFileBody)}
        )
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        console.log("logfile create was successful");
                    }else{
                        alert ("Response from save log file not valid!" +
                            " status is: " + statusCode +
                            " message is: " + output.body.message)
                       
                    }
            });
        }
    });
  
}

onNavigate = (path) => {
    const { navigate, location } = this.props;

    const targetPath = `/${path}`;
    // Only navigate if we aren’t already there
    if (location.pathname !== targetPath) {
        navigate(`/${path}`, { replace: true });
    }
};


    render() {
        // Still loading
        if (!this.state.initialized) {
            return <WaitTimeSpinner />;
        }
         
        // Initialization complete — App.js will determine next UI
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
    (withRouterCompat(AppInitializer));
